import $ from 'jquery';

export function processSelectPlanKeyPress(event) {

  // Check if the event target is a radio button or a checkbox
  const currentOption = document.activeElement;
  const optionGroup = event.currentTarget;

  // Only proceed if the focused element is one of our radio options
  if (!$.contains(optionGroup, currentOption)) {
    return;
  }
  const $focusedOptions = $(optionGroup).find('.selector-item');

  const activePosition = $focusedOptions.index(currentOption);

  let nextOption;

  // Handle arrow key presses
  if (['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
    event.preventDefault();
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextOption = (activePosition + 1 + $focusedOptions.length) % $focusedOptions.length;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextOption = (activePosition - 1 + $focusedOptions.length) % $focusedOptions.length;
    }
    $focusedOptions[nextOption].focus();
  }

  if (event.key === ' ' || event.key === 'Enter') {
    event.preventDefault();
    // Trigger click on the focused option
    $(currentOption).trigger('click');
  }
}

// Add a keydown event listener to the group for arrow key navigation
$('.selector-items-wrapper').on('keydown', processSelectPlanKeyPress);
